module.exports = __webpack_public_path__ + "static/media/youtube.01888491.png";